export enum ProjectIDs {
  STOREFRONT = 'headless-storefront-sdk-for-gaming',
  LOTTERY_PLATFORM = 'innovative-lottery-saas-platform',
  MONITORING_PLATFORM = 'predictive-monitoring-platform',
  ECO_SYSTEM = 'ecosystem-for-social-finance-solution',
  PAYMENT_PLATFORM = 'payment-orchestration-platform',
  AUTOMATED_EXCHANGE = 'automated-exchange',
  HEALTH_PLATFORM = 'digital-healthcare-platform'
}
